import { ethers } from 'ethers';
import { erc20Abi } from '@/abis';
import { createMetaMaskProvider } from '@/utils/metamask';

export async function getWalletTokenBalance(
  tokenAddress: string,
  decimals: number,
  userAddress?: string
): Promise<string> {
  try {
    const provider = createMetaMaskProvider();
    if (!provider) return '0.00';
    const address = userAddress || (await provider.getSigner().then(s => s.getAddress()));
    if (!address) return '0.00';

    const contract = new ethers.Contract(tokenAddress, erc20Abi, provider);
    const bal = await contract.balanceOf(address);
    const formatted = ethers.formatUnits(bal, decimals);
    const num = parseFloat(formatted);
    return Number.isNaN(num)
      ? '0.00'
      : num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
  } catch {
    return '0.00';
  }
}


export async function getNativeBalance(userAddress?: string): Promise<string> {
  try {
    const provider = createMetaMaskProvider();
    if (!provider) return '0.00';
    const address = userAddress || (await provider.getSigner().then(s => s.getAddress()));
    if (!address) return '0.00';
    const bal = await provider.getBalance(address);
    const formatted = ethers.formatUnits(bal, 18);
    const num = parseFloat(formatted);
    return Number.isNaN(num)
      ? '0.00'
      : num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
  } catch {
    return '0.00';
  }
}


